/**
 * 政务菜单、路由
 */
export default {
  govMenu: [ // todo 修改后平台需对应更改
    {
      title: '概况',
      key: 'dataView',
      icon: 'line-chart',
      subMenu: [
        { title: '数据概览', route: 'allVis', key: 'dataView' }
      ]
    },
    {
      title: '预警管理',
      key: 'warningManage',
      icon: 'setting',
      subMenu: [
        { title: '预警设置', route: 'warningSetting', key: 'warningManage' },
        { title: '预警提醒', route: 'remindWarn', key: 'warningManage' },
        { title: '人员预警', route: 'blackList', key: 'warningManage' },
        { title: '人员预警记录', route: 'blackListRecord', key: 'warningManage' }
      ]
    },
    {
      title: '管理中心',
      key: 'government',
      icon: 'setting',
      subMenu: [
        { title: '角色管理', route: 'govRole', key: 'government' },
        { title: '用户管理', route: 'govAccount', key: 'government' },
        { title: '操作日志', route: 'operationLog', key: 'government' }
      ]
    }
  ],
  govRoutes: [ // todo 修改后平台需对应更改
    /** 人员预警 start */
    {
      path: '/blackList',
      name: 'blackList',
      menuKey: 'blackList',
      btnList: [
        {title: '新增', key: 'addbtn'},
        {title: '开门日志', key: 'log'},
        {title: '修改', key: 'edit'},
        {title: '删除', key: 'delete'}
      ],
      meta: {title: '人员预警', breadNumber: 0}
    },
    {
      path: '/blackList/add',
      name: 'addBlackList',
      menuKey: 'blackList',
      btnList: [
        {title: '提交', key: 'submit'}
      ],
      meta: {title: '添加人员', breadNumber: 1}
    },
    {
      path: '/blackList/log',
      name: 'lookOpenLog',
      menuKey: 'blackList',
      btnList: [
        {title: '查看', key: 'show'}
      ],
      meta: {title: '开门日志', breadNumber: 1}
    },
    {
      path: '/blackListRecord',
      name: 'blackListRecord',
      menuKey: 'blackListRecord',
      btnList: [
        {title: '查看', key: 'show'}
      ],
      meta: {title: '人员预警记录', breadNumber: 0}
    },
    /** 人员预警 end */

    {
      path: '/warningSetting',
      name: 'warningSetting',
      menuKey: 'warningSetting',
      btnList: [
        {title: '新增', key: 'addbtn'},
        {title: '修改', key: 'edit'},
        {title: '删除', key: 'delete'}
      ],
      meta: {title: '预警设置列表', breadNumber: 0}
    },
    {
      path: '/remindWarn',
      name: 'remindWarn',
      menuKey: 'remindWarn',
      btnList: [
        {title: '详情', key: 'detail'}
      ],
      meta: {title: '预警提醒列表', breadNumber: 0}
    },
    {
      path: '/remindWarn/detail',
      name: 'remindDetail',
      menuKey: 'remindWarn',
      btnList: [],
      meta: {title: '预警详情', breadNumber: 1}
    },

    {
      path: '/allVis',
      name: 'allVis',
      menuKey: 'allVis',
      meta: {title: '浩邈智慧社区数据概览', breadNumber: 0}
    },
    {
      path: '/communityVis',
      name: 'communityVis',
      menuKey: 'allVis',
      meta: {title: '某社区数据概览', breadNumber: 0}
    },
    {
      path: '/govRole',
      name: 'govRole',
      menuKey: 'govRole',
      btnList: [
        {title: '新增', key: 'addbtn'},
        {title: '批量删除', key: 'batchDel'},
        {title: 'API权限', key: 'apiAuth'},
        {title: '视图权限', key: 'viewAuth'},
        {title: '修改', key: 'edit'},
        {title: '删除', key: 'delete'}
      ],
      meta: {title: '政务角色', breadNumber: 0}
    },
    {
      path: '/govRole/add',
      name: 'addGovrole',
      menuKey: 'govRole',
      btnList: [
        {title: '提交', key: 'submit'}
      ],
      meta: {title: '新增政务角色', breadNumber: 1}
    },
    {
      path: '/govRole/api',
      name: 'govApiAuth',
      menuKey: 'govRole',
      btnList: [
        {title: '提交', key: 'submit'}
      ],
      meta: {title: '配置api权限', breadNumber: 1}
    },
    {
      path: '/govRole/view',
      name: 'govViewAuth',
      menuKey: 'govRole',
      btnList: [
        {title: '提交', key: 'submit'}
      ],
      meta: {title: '配置视图权限', breadNumber: 1}
    },
    {
      path: '/govAccount',
      name: 'govAccount',
      menuKey: 'govAccount',
      btnList: [
        {title: '新增', key: 'addbtn'},
        {title: '批量删除', key: 'batchDel'},
        {title: '状态切换', key: 'status'},
        {title: '重置密码', key: 'resetPwd'},
        {title: '修改', key: 'edit'},
        {title: '删除', key: 'delete'}
      ],
      meta: {title: '政务账号', breadNumber: 0}
    },
    {
      path: '/govAccount/add',
      name: 'addGovAccount',
      menuKey: 'govAccount',
      btnList: [
        {title: '提交', key: 'submit'}
      ],
      meta: {title: '新增政务账号', breadNumber: 1}
    },
    {
      path: '/operationLog',
      name: 'operationLog',
      menuKey: 'operationLog',
      btnList: [
        {title: '账号详情', key: 'accountDetail'}
      ],
      meta: {title: '管理员操作日志', breadNumber: 0}
    }
  ]
};



// WEBPACK FOOTER //
// ./src/js/govMenuRoutes.js